import { render, staticRenderFns } from "./FireInsurance.vue?vue&type=template&id=29a40430&"
import script from "./FireInsurance.vue?vue&type=script&lang=js&"
export * from "./FireInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports